/* eslint-disable no-restricted-globals */
import { useEffect, useMemo, useState } from "react"
import { UseAlert } from "hook/alert-hook"
import { Button, Container, Nav, Navbar, NavDropdown } from "react-bootstrap"
import { UseAuth } from "hook/auth-hook"
import { HeaderNavegationList } from "helper/adapter/headerNavigation/header-navegation-adapter"
import { itemMenuVisivelPorFluxo, readFluxoAprovacaoCompletoFlag } from "helper/fluxo-aprovacao-empresa-helper"
import { Store } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import { getEnv } from "helper/window-helper"
import { hasAdminEquivalentRole } from "helper/role-helper"
import { clearLocalStoragePlanning, getLocalStorage, setLocalStorege } from "data/cache/localstorage-cache"
import { useNavigate } from "react-router-dom"
import { FaArrowLeft, FaHome } from "react-icons/fa"
import React from "react"

export const HeaderNavegation = React.memo(() => {

    const LOCALSTORAGE_TOKEN_USER_CHANGE = getEnv("REACT_APP_LOCALSTORAGE_TOKEN_USER_CHANGE")!
    const changUserTokenLocalStorage: { token: string } = getLocalStorage(LOCALSTORAGE_TOKEN_USER_CHANGE)

    let navigate = useNavigate()

    const [hideToOriginUser, updateHideToOriginlUser] = useState<boolean>(true)
    const [hideSwitchInternalUser, updateHideSwitchInternalUser] = useState<boolean>(true)

    const [headerNavegation, updateHeaderNavegation] = useState<any[]>(HeaderNavegationList)

    // Flag CON_BLN_FLUXO_APROVACAO_COMPLETO da empresa — decide qual item de pedido
    // aparece no menu (novo x legado). null enquanto não resolve: nenhum dos dois aparece (nunca
    // os dois juntos). A flag legada CON_BLN_FLUXO_APROVACAO não participa desta decisão.
    const [fluxoAprovacaoCompletoFlag, updateFluxoAprovacaoCompletoFlag] = useState<boolean | null>(null)

    const { isLoggedIn, loggedUserData } = UseAuth()

    useEffect(() => {
        // Sem sessão válida (ex.: tela de login) não dispara chamada autenticada: o RestCall veria
        // token ausente/expirado e faria redirect + location.reload(), causando refresh infinito.
        if (!isLoggedIn) {
            updateFluxoAprovacaoCompletoFlag(null)
            return
        }
        let ativo = true
        readFluxoAprovacaoCompletoFlag(loggedUserData?.companyId).then(flag => {
            if (ativo) {
                updateFluxoAprovacaoCompletoFlag(flag)
            }
        })
        return () => { ativo = false }
    }, [isLoggedIn, loggedUserData?.companyId])

    useMemo(() => {

        if (loggedUserData?.role) {
            loggedUserData.role.forEach(value => {
                HeaderNavegationList.map(nav => {
                    return nav.navItem.map(item => {
                        if (item.role.includes(value)) {
                            nav.visible = true
                            item.visible = true
                        }
                    })
                })
            })
            if (loggedUserData.role.includes("IS_GRUPO_EMPRESA") || hasAdminEquivalentRole(loggedUserData.role)) {
                updateHideSwitchInternalUser(false)
            }
        }

        if (changUserTokenLocalStorage !== undefined && changUserTokenLocalStorage !== null &&
            changUserTokenLocalStorage.token !== undefined && changUserTokenLocalStorage.token !== "") {
            updateHideToOriginlUser(false)
        }

        updateHeaderNavegation(HeaderNavegationList)

    }, [loggedUserData])

    const { messageAlert, showAlert } = UseAlert()

    const AlertMemo = useMemo(() => Alert(), [messageAlert, showAlert])

    function Alert() {
        if (messageAlert?.show) {
            return (
                <>
                    {
                        Store.addNotification({
                            title: "",
                            message: messageAlert.content,
                            type: messageAlert.color,
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: messageAlert.time ? messageAlert.time : 5000,
                                onScreen: true,
                                showIcon: true
                            }
                        })
                    }
                </>
            )
        } else {
            return (
                <></>
            )
        }
    }

    function changeBackToOriginUser() {
        localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_TOKEN_USER_CHANGE"))
        localStorage.removeItem('is-super-user')
        clearLocalStoragePlanning()
        navigate("/")
        location.reload()
    }

    function navigateToHome() {
        navigate("/")
        location.reload()
    }

    useEffect(() => {
        if (messageAlert?.time) {
            setTimeout(() => {
                showAlert({
                    show: false,
                    content: "",
                    color: messageAlert.color
                })
            }, messageAlert.time)
        }
    }, [messageAlert, showAlert])

    return (
        <>
            <Navbar bg="dark" expand="lg" variant="dark">
                <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Button onClick={navigateToHome} size="sm" variant="secondary" style={{marginRight: "15px"}}>
                        <FaHome size={15} />
                    </Button>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            {headerNavegation.map((nav, indexNav) => {
                                if (nav.visible) {
                                    return (
                                        <NavDropdown title={nav.navTitle} id={nav.idNav} key={indexNav}>
                                            {nav.navItem.map((item: any, indexItem: number) => {
                                                if (itemMenuVisivelPorFluxo(item.route, item.visible, fluxoAprovacaoCompletoFlag)) {
                                                    return (
                                                        <NavDropdown.Item href={item.route} key={indexItem}>{item.title}</NavDropdown.Item>
                                                    )
                                                }
                                            })}
                                        </NavDropdown>
                                    )
                                }
                            })}
                        </Nav>
                        <div hidden={hideToOriginUser} className="me-2">
                            <Button onClick={changeBackToOriginUser} size="sm" variant="outline-primary">
                                <FaArrowLeft size={15} /> Usuario de Origem
                            </Button>
                        </div>
                        <div hidden={hideSwitchInternalUser}>
                            <Button href="/troca-usuario-interno-empresa" size="sm" variant="secondary" >Trocar Usuario</Button>
                        </div>
                        {AlertMemo}
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )

});


